module.exports = __webpack_public_path__ + "img/parallax1-850p.c72d65ec.jpg";